import React, { useEffect, useRef } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { FormikButton, FormikGrid, FormikTextField } from '@sierralabs/react-material-ui-formik';
import { useCreateFolder } from '../hooks/useCreateFolder';
const CreateFolderDialog = props => {
    const { open, folderId, onCancel, onCreated } = props;
    const onCreatedRef = useRef(onCreated);
    const formikRef = useRef(null);
    const { data, isLoading, error, createFolder } = useCreateFolder();
    useEffect(() => {
        onCreatedRef.current = onCreated;
    }, [onCreated]);
    useEffect(() => {
        var _a;
        (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.setSubmitting(isLoading);
    }, [isLoading]);
    useEffect(() => {
        var _a;
        if (data) {
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, data);
        }
    }, [data]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: onCancel },
        React.createElement(Formik, { innerRef: formikRef, initialValues: { name: '' }, validationSchema: Yup.object({
                name: Yup.string().required('Required')
            }), onSubmit: dto => createFolder(Object.assign(Object.assign({}, dto), { parentId: folderId })) },
            React.createElement(Form, { autoComplete: 'off' },
                React.createElement(DialogTitle, null, "New Folder"),
                React.createElement(DialogContent, null,
                    React.createElement(DialogContentText, null, "Specify the name of the folder."),
                    React.createElement(FormikGrid, null,
                        React.createElement(FormikTextField, { autoFocus: true, type: 'text', name: 'name', label: 'Folder Name', disabled: isLoading })),
                    error && React.createElement(Alert, { severity: 'error' }, error.message)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: onCancel }, "Cancel"),
                    React.createElement(FormikButton, null, "Create"))))));
};
export default CreateFolderDialog;
//# sourceMappingURL=CreateFolderDialog.js.map